import React from 'react';
import { ArrowUpCircle } from 'lucide-react';
import { BannerContainer } from '../BannerContainer';
import { BannerContent } from '../BannerContent';
import { BannerActions } from '../BannerActions';
import { PlanHighlight } from '../PlanHighlight';
import { FeaturesGrid } from '../FeaturesGrid';
import { BANNER_THEMES, FEATURE_SETS, ACTION_CONFIGS } from '../config/bannerConfig';
import { Sparkles } from 'lucide-react';

interface TrialBannerProps {
  onDismiss?: () => void;
  className?: string;
}

export const TrialBanner: React.FC<TrialBannerProps> = ({
  onDismiss,
  className
}) => {
  const theme = BANNER_THEMES.trial;
  const features = FEATURE_SETS.trial;
  const actions = ACTION_CONFIGS.trial;

  return (
    <BannerContainer
      variant="gradient"
      theme={theme.theme}
      onDismiss={onDismiss}
      className={className}
    >
      <BannerContent
        layout="centered"
        emoji={theme.emoji}
        emojiAnimation={theme.emojiAnimation}
        title={theme.title}
        description={theme.description}
        titleColor={theme.titleColor}
        descriptionColor={theme.descriptionColor}
      >
        {/* Credits highlight */}
        <PlanHighlight
          type="credits"
          value="100 Free Credits"
          label="100 Free Credits"
          sublabel="Perfect for testing AI features"
          icon={<Sparkles className="h-5 w-5" />}
          theme="dark"
        />

        {/* Action buttons */}
        <BannerActions
          primary={{
            ...actions.primary,
            icon: <ArrowUpCircle className="h-5 w-5 mr-2" />,
            onClick: onDismiss
          }}
          secondary={{
            ...actions.secondary,
            onClick: onDismiss
          }}
        />

        {/* Features preview */}
        <FeaturesGrid 
          features={features}
          variant="dark"
        />
      </BannerContent>
    </BannerContainer>
  );
};